import ErrorBoundary from './errorBoundary';

export default ErrorBoundary